import {inject} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {from, map, switchMap} from 'rxjs';

import * as RouterActions from '@app/core/store/router/router.actions';
import {Router} from '@angular/router';
import {UserActionGroup} from "@app/users/store/users.actions";

export const navigateToUsers$ =
  createEffect((actions$ = inject(Actions), router = inject(Router)) =>
      actions$.pipe(
        ofType(RouterActions.NavigateToUsers),
        switchMap(() => from(router.navigate(['administration', 'people'])).pipe(
          map(() => RouterActions.NavigateToUsersSuccess())
        ))
      ),
    { functional: true }
  );

export const navigateToUsersSuccess$ =
  createEffect((actions$ = inject(Actions)) =>
      actions$.pipe(
        ofType(RouterActions.NavigateToUsersSuccess),
        map(() => UserActionGroup.getUsersRequested()),
      ),
    { functional: true }
  );
